import { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";

const ScrollToTopBtn = () => {
    const [showScrollToTopBtn, setShowScrollToTopButton] = useState(false);

    useEffect(() => {
        const handleScrollToTopVisibility = () => {
            setShowScrollToTopButton(window.scrollY > 300);
        }
        window.addEventListener("scroll", handleScrollToTopVisibility);
        
        return () => window.removeEventListener("scroll", handleScrollToTopVisibility);
    }, []);

    const handleScroll = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });    
    }

    return (<>
        {showScrollToTopBtn && (
            <button onClick={handleScroll} className='scroll-to-top d-flex justify-content-center align-items-center'>
                <FaArrowUp />
            </button>
        )}
    </>);
};

export default ScrollToTopBtn;
